import React, { useContext } from 'react';
import { Box, Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';

import ModalsContext from 'src/context/modals.jsx';

const SmallCardsCardsTable = ({ fields, remove, update, replace, all_categories }) => {
	if (!fields?.length) return <></>;

	const modals_context = useContext(ModalsContext);

	return (
		<Grid item xs={12}>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ pl: 3 }}>Header</TableCell>
							<TableCell align="left">Subheader</TableCell>
							<TableCell align="left">Description</TableCell>
							<TableCell align="left">Category</TableCell>
							<TableCell align="right" sx={{ pr: 3 }}>
								Actions
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{fields.map(({ header, subheader, desc, category }, index) => (
							<TableRow key={index}>
								<TableCell sx={{ pl: 3 }}>
									<Typography align="left" variant="subtitle1">
										{header}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{subheader}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{desc}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{category}
									</Typography>
								</TableCell>

								<TableCell sx={{ pr: 1, display: 'flex' }} align="right">
									<Stack direction="row">
										<Box sx={{ width: '100px', position: 'relative' }}>
											<IconButton
												sx={{ float: 'left', display: index === fields.length - 1 ? 'none' : '' }}
												color="primary"
												size="large"
												onClick={(event) => {
													event.stopPropagation();
													replace(index, 1);
												}}
											>
												<KeyboardDoubleArrowDownIcon />
											</IconButton>

											<IconButton
												sx={{ float: 'right', display: index === 0 ? 'none' : '' }}
												color="primary"
												size="large"
												onClick={(event) => {
													event.stopPropagation();
													replace(index, -1);
												}}
											>
												<KeyboardDoubleArrowUpIcon />
											</IconButton>
										</Box>
										<IconButton
											color="secondary"
											size="large"
											onClick={() =>
												modals_context.show('section_small_cards_card_edit', {
													data: fields[index],
													clb: (data) => update(index, data),
													all_categories,
												})
											}
										>
											<EditTwoToneIcon sx={{ fontSize: '1.3rem' }} />
										</IconButton>
										<IconButton
											color="error"
											size="small"
											onClick={() =>
												modals_context.show('item_delete', {
													clb: () => remove(index),
												})
											}
										>
											<DeleteTwoToneIcon fontSize="small" />
										</IconButton>
									</Stack>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Grid>
	);
};

export default SmallCardsCardsTable;
